import { Navigate } from 'react-router-dom'

export default function RedirectByRole() {
  // if (isLoading) {
  //   return <ContentLoader />
  // }
  // if (data?.role === 'operator') {
  //   return <Navigate to="/dashboard/home" />
  // }
  // if (data?.role === 'editor') {
  //   return <Navigate to="/dashboard/articles" />
  // }
  return <Navigate to="/dashboard/orders" />
}
